<template>
    <form class="form-control-line m-t-2" @submit.prevent="onSubmit">
        <div class="card text-white bg-danger" v-if="errors">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}: {{error}}
                </p>
            </div>
        </div>
        <div class="form-group">
            <label for="tag_name">Tag Name:</label>
            <input type="text" name="tag_name" id="tag_name" v-model="tag.name" class="form-control form-control-line">
            <div v-if="$v.tag.name.$error">
                <div class="text-danger" v-if="!$v.tag.name.required">Tag Name is required.</div>
            </div>
        </div>
        <div class="form-group">
            <label for="tag_content">
                Content:
            </label>
            <small class="form-text text-muted mt-0">
                One line - one value
            </small>
            <textarea class="form-control" rows="15" name="tag_content" id="tag_content"
                      v-model="tag.content"></textarea>
            <div v-if="$v.tag.content.$error">
                <div class="text-danger" v-if="!$v.tag.content.required">Tag Content is required.</div>
            </div>
        </div>
        <div class="form-actions">
            <button type="submit" class="btn btn-success btn-rounded text-uppercase waves-effect waves-light m-r-5"
                    v-show="!loadingStatus">
                Save
            </button>
            <button class="btn btn-success btn-rounded text-uppercase waves-effect waves-light m-r-5" type="button"
                    disabled v-show="loadingStatus">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Loading...
            </button>
            <router-link to="/tags" class="btn btn-info btn-rounded text-uppercase waves-effect waves-light">Back
            </router-link>
        </div>
    </form>
</template>

<script>
    import required from 'vuelidate/src/validators/required';
    import TagService from '../../services/TagService';

    export default {
        name: 'TagForm',
        props: ['id'],
        data() {
            return {
                tag: {
                    name: null,
                    content: null,
                },
                loadingStatus: false,
                errors: ''
            }
        },
        validations: {
            tag: {
                name: {required},
                content: {required},
            }
        },
        mounted() {
            if (this.id) {
                TagService.getTag(this.id).then(response => {
                    this.tag.name = response.data.name;
                    this.tag.content = response.data.content.join('\n');
                    this.$emit('hidePreloader', true)
                });
            }
        },
        methods: {
            async onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                this.loadingStatus = true;
                let tagData = {
                    name: this.tag.name,
                    content: this.tag.content.split('\n')
                };
                let submitMethod = null;
                if (this.id) {
                    submitMethod = TagService.updateTag(this.id, JSON.stringify(tagData));
                } else {
                    submitMethod = TagService.createTag(JSON.stringify(tagData));
                }

                await submitMethod.then(response => {
                    if (response.data.error !== undefined) {
                        this.errors = response.data.error;
                    } else {
                        switch (response.status) {
                            case 201:
                                this.$snotify.success('Tag ' + response.data.name + ' added successfully!', 'Success!!!');
                                this.$router.push({name: 'tags'});
                                break;
                            case 200:
                                this.$snotify.success('Tag ' + response.data.name + ' updated successfully!', 'Success!!!');
                                this.$router.push({name: 'tags'});
                                break;
                        }
                    }
                    this.loadingStatus = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>